import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createProject } from '@services/projects.service';
import { PROJECTS_QUERY_KEY } from './useProjects';

export const useCreateProject = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => createProject(body),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: PROJECTS_QUERY_KEY });
        },
    });
};
